import { type TransactionHash, TRANSACTION_TYPES, EVENT_SUFFIXES, type Address } from "@/types";
import { createEventEmitter } from "@/events";

export const MULTIVOTE_EVENTS = {
    SUCCESS: `${TRANSACTION_TYPES.MULTIVOTE}:${EVENT_SUFFIXES.SUCCESS}`,
} as const;

export interface MultiVoteSuccessPayloads {
    transactionHash: TransactionHash;
    assets: Address[];
    unwindingEpochs: number[];
    liquidVotes: { farm: Address; weight: bigint }[][];
    illiquidVotes: { farm: Address; weight: bigint }[][];
}

export interface MultiVoteEventPayloads extends Record<string, unknown> {
    [MULTIVOTE_EVENTS.SUCCESS]: MultiVoteSuccessPayloads;
}

export const multiVoteEventEmitter = createEventEmitter<MultiVoteEventPayloads>();
